import React from "react";
import ReactDOM from "react-dom";
import images from "../logo.json"
import AnimateOnChange from "react-animate-on-change";
import "./Slider.css";

class Slider extends React.Component {

    state = {
        images: images
    }

    handleLeft = () => {
        let array = [];
        let newArray = array.concat(this.state.images);
        let firstElement = newArray.shift();
        newArray.push(firstElement);
        this.setState({images: newArray});
    };

    handleRight = () => {
        let array = [];
        let newArray = array.concat(this.state.images);
        let lastElement = newArray.pop();
        newArray.unshift(lastElement);
        this.setState({images: newArray});
    };

    filterImages = (imagesArray, screenWidth) => {
        let number_of_logos;
        let center_logo;
        let logo_size;
        if (screenWidth > 1145) {
            number_of_logos = 5;
            center_logo = 2;
            logo_size = "client-logo-size";
        } else if (screenWidth <= 1145 && screenWidth >= 786) {
            number_of_logos = 5;
            center_logo = 2;
            logo_size = "client-logo-size-medium";
        } else {
            number_of_logos = 3;
            center_logo = 1;
            logo_size = "client-logo-size-small";
        }
        return imagesArray.map((element, index) => {
            return index < number_of_logos
                ? <img
                        key={index}
                        className={logo_size}
                        id={index === center_logo
                        ? "current-logo-selected"
                        : ""}
                        src={element.image}/>
                : null;
        });
    };

    render() {

        const left_arrow_size = this.props.screenWidth.width <= 1145
            ? "left arrow small-arrow"
            : "left arrow regular-arrow";
        const right_arrow_size = this.props.screenWidth.width <= 1145
            ? "right arrow small-arrow"
            : "right arrow regular-arrow";

        return (
            <div id="client" className="slider-container slider-background-color pb-5">
                <div className="text-center title pt-5 pb-5">Our Clients</div>
                <div className="row">
                    <div className="col">
                        <div className="">
                            <i
                                onClick={() => {
                                this.handleLeft();
                            }}className={left_arrow_size}></i>
                        </div>
                    </div>
                    <div className="col-10 col-xs text-center pt-4 logos-container">
                        <AnimateOnChange
                            baseClassName="animation-logos-container"
                            animationClassName="logo-clicked"
                            animate={true}>
                            {this.filterImages(this.state.images, this.props.screenWidth.width)}
                        </AnimateOnChange>
                    </div>
                    <div className="col">
                        <div className="">
                            <i
                                onClick={() => {
                                this.handleRight();
                            }}className={right_arrow_size}></i>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

};

export default Slider;



// WEBPACK FOOTER //
// ./src/components/Mainpage/Client/Slider/Slider.js